<template>
  <div>
    <OtherHeader :img_header="header_image" header="ตั้งค่าเว็บไซต์อื่นๆ" link_back="managewebsite"/>
    <MenuOther/>
    <Policy_page/>
  </div>
</template>

<script>
import MenuOther from "@/components/admin/manage_website/other_setting/menu_other/MenuOther";
import Policy_page from "@/components/admin/manage_website/other_setting/Policy_page";
import OtherHeader from "@/components/admin/manage_website/other_setting/menu_other/OtherHeader";
import HeaderImage from "@/assets/policy.png";
export default {
  name: "PolicyPage",
  components: {
    OtherHeader,
    Policy_page,
    MenuOther
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
